import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import React from "react";
import { formatDateTime } from "utils/date";
import GridListItem from "../grid/GridListItem";

const PatientRecords = ({
  patientRecords = [],
  value,
  handleSelect,
  handleRemove,
}) => {
  return (
    <RadioGroup
      value={value}
      onChange={(e, value) => {
        handleSelect(value);
      }}
    >
      {patientRecords.map((patientRecord) => (
        <Grid
          container
          alignItems="flex-start"
          style={{
            padding: "8px",
            marginTop: "8px",
            background:
              value === patientRecord?.evoke_id ? "#F1F6E3" : "#F5F5F5",
          }}
        >
          <Grid item sm={1} md={1} lg={1}>
            <FormControlLabel
              value={patientRecord?.evoke_id}
              control={<Radio />}
            />
          </Grid>
          <Grid item sm={10} md={10} lg={10}>
            <h2 className="ml-2">
              {patientRecord?.firstName} {patientRecord?.lastName}
            </h2>
            <Grid container spacing={0}>
              <GridListItem
                size="4"
                title="Evoke ID"
                subTitle={patientRecord?.evoke_id ?? "—"}
              />

              <GridListItem
                size="4"
                title="DOB"
                subTitle={
                  patientRecord?.dob ? formatDateTime(patientRecord?.dob) : "—"
                }
              />

              <GridListItem
                size="4"
                title="DOI"
                subTitle={
                  patientRecord?.doi ? formatDateTime(patientRecord?.doi) : "—"
                }
              />

              <GridListItem
                size="12"
                title="Device"
                subTitle={patientRecord?.deviceInformation?.modelName ?? "—"}
              />

              <GridListItem
                size="12"
                title="Device Serial Number"
                subTitle={patientRecord?.deviceInformation?.modelNumber ?? "—"}
              />
            </Grid>
          </Grid>
          {handleRemove && (
            <Grid
              item
              sm={1}
              md={1}
              lg={1}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <IconButton
                size="small"
                onClick={() => handleRemove(patientRecord?.evoke_id)}
                style={{ color: "#666" }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Grid>
          )}
        </Grid>
      ))}
    </RadioGroup>
  );
};

export default PatientRecords;
